import useTheme from '../../hooks/ui/useTheme';

interface Props {
  className?: string;
  style?: object;
  color?: string;
  fill?: boolean;
}

export default function InfoIcon(props: Props) {
  const { className, color, style, fill } = props;
  const theme = useTheme();

  if (!fill) {
    return (
      <svg
        className={className ?? 'h-6 w-6'}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <g clipPath="url(#clip0_25680_32710)">
          <circle cx="8" cy="8" r="7.75" stroke={color ?? theme.color.gray['100']} strokeWidth="0.5" />
          <path
            d="M8.66602 11.3337L8.66276 11.402C8.62854 11.7381 8.34447 12.0003 7.99935 12.0003C7.65423 12.0003 7.37016 11.7381 7.33594 11.402L7.33268 11.3337L7.33268 7.33366C7.33268 6.96547 7.63116 6.66699 7.99935 6.66699C8.36754 6.66699 8.66602 6.96547 8.66602 7.33366L8.66602 11.3337Z"
            fill={color ?? theme.color.gray['100']}
          />
          <path
            d="M8.66276 5.40202C8.62857 5.73814 8.34449 6.00033 7.99935 6.00033C7.65421 6.00033 7.37013 5.73814 7.33594 5.40202L7.33268 5.33366C7.33268 4.96547 7.63116 4.66699 7.99935 4.66699C8.36754 4.66699 8.66602 4.96547 8.66602 5.33366L8.66276 5.40202Z"
            fill={color ?? theme.color.gray['100']}
          />
        </g>
        <defs>
          <clipPath id="clip0_25680_32710">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg className={className ?? 'h-6 w-6'} viewBox="0 0 26 26" fill="none" style={style}>
      <circle r="11.6667" transform="matrix(-1 0 0 1 13.9974 14.0007)" fill={color ?? theme.color.gray['100']} />
      <path d="M14 14L14 21" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <path d="M14 9.16602L14 7.99935" stroke="white" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
